/** Claves de preferencias de notificación (Ajustes → Notificaciones). */
export const NOTIFICATION_PREF_KEYS = [
  'pedido',
  'mensaje',
  'oferta',
  'val',
  'superado',
  'puja_fin',
  'puja_cerca',
  'wishlist',
  'precio',
  'evento',
  'seguidor',
  'grooves',
  'novedades',
];

export const DEFAULT_NOTIFICATION_PREFS = Object.freeze({
  pedido: true,
  mensaje: true,
  oferta: true,
  val: true,
  superado: true,
  puja_fin: true,
  puja_cerca: true,
  wishlist: true,
  precio: true,
  evento: true,
  seguidor: false,
  grooves: true,
  novedades: true,
});

/**
 * Fusiona prefs guardadas en BD con valores por defecto.
 * @param {object|null|undefined} raw
 */
export function parseNotificationPrefs(raw) {
  const base = { ...DEFAULT_NOTIFICATION_PREFS };
  if (!raw || typeof raw !== 'object') return base;
  for (const k of NOTIFICATION_PREF_KEYS) {
    if (typeof raw[k] === 'boolean') base[k] = raw[k];
  }
  return base;
}

/**
 * @param {string} userId
 * @param {Record<string, boolean>} prefs
 */
export function notificationPrefsPatch(prefs) {
  const out = {};
  for (const k of NOTIFICATION_PREF_KEYS) {
    if (typeof prefs[k] === 'boolean') out[k] = prefs[k];
  }
  return out;
}
